// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2jjgO","colMin":"styles_colMin__1cB1G","colCheckbox":"styles_colCheckbox__1cMIQ"};